"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// this is just Luhn's algorithm, more on wikipedia
function luhnAlgorithm(input) {
    var sum = 0;
    if (typeof input === "number") {
        input = "" + input;
    }
    var l = input.length;
    for (var i = 0; i < l; i++) {
        var v = parseInt(input[i]);
        v *= 2 - (i % 2);
        if (v > 9) {
            v -= 9;
        }
        sum += v;
    }
    return (10 - (sum % 10)) % 10;
}
exports.luhnAlgorithm = luhnAlgorithm;
